<div class="sidenav" [ngClass]="collapsed ? 'sidenav-collapsed':''" >
  <div class="logo-container">
  </div>
  <ul class="sidenav-nav">
      <li class="sidenav-nav-item" *ngFor="let data of sidebardata">
<a href="" class="sidenav-nav-link" [routerLink]="[data.routerLink]" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" *ngIf="data.show">              <img  class="sidenav-link-icon" [src]="[data.icon]">
              <span class="sidenav-link-text" *ngIf="collapsed">{{data.label}}</span>
          </a>
      </li>
      <li class="p-3">Version {{version}}</li>
  </ul>
</div>
